import { useState, useEffect } from 'react';
import { usePatient } from '../contexts/PatientContext';
import { patientApiService } from '../services/api';

export function useOrgCalendarDisplay() {
  const { patient } = usePatient();
  const [calendarDisplay, setCalendarDisplay] = useState<Record<string, any>>({});

  useEffect(() => {
    const orgId = patient?.organization_id;
    if (!orgId) return;
    let cancelled = false;
    patientApiService.getOrganizationPublic(orgId)
      .then((org: any) => {
        if (!cancelled) setCalendarDisplay(org?.settings?.calendar_display || {});
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [patient?.organization_id]);

  return calendarDisplay;
}
